import React from 'react';
import { useAppSelector } from '../../store/hooks';
import { CText, CHeader } from '../../components/common';

const TermsAndCondition: React.FC = () => {
  const colors = useAppSelector((state) => state.theme.theme);

  const termsData = [
    {
      title: '1. Acceptance of Terms',
      content: [
        'By accessing and using Yantrai, you accept and agree to be bound by the terms and provisions of this agreement.',
        'If you do not agree to abide by these terms, please do not use this service.',
      ],
    },
    {
      title: '2. Use of Service',
      content: [
        'You must be at least 18 years old to use this service.',
        'You are responsible for maintaining the confidentiality of your account and password.',
        'You agree to accept responsibility for all activities that occur under your account.',
      ],
    },
    {
      title: '3. Investment Disclaimer',
      content: [
        'All investments carry risk. Past performance is not indicative of future results.',
        'The information provided on this platform is for informational purposes only and should not be considered as financial advice.',
        'Always consult with a qualified financial advisor before making investment decisions.',
      ],
    },
    {
      title: '4. Expert Services',
      content: [
        'Expert consultations are provided by SEBI-registered professionals.',
        'Session fees are non-refundable once a session has been completed.',
        'Cancellations must be made at least 24 hours before the scheduled session for a full refund.',
      ],
    },
    {
      title: '5. Prohibited Activities',
      content: [
        'You may not use this service for any illegal or unauthorized purpose.',
        'You must not transmit any worms, viruses, or any code of a destructive nature.',
        'Any violation of these terms may result in immediate termination of your account.',
      ],
    },
    {
      title: '6. Intellectual Property',
      content: [
        'All content, trademarks, and data on this platform are the property of Yantrai.',
        'You may not reproduce, distribute, or create derivative works without our express written consent.',
      ],
    },
    {
      title: '7. Limitation of Liability',
      content: [
        'Yantrai shall not be liable for any indirect, incidental, special, consequential, or punitive damages.',
        'Our total liability to you for any claims arising out of this agreement shall not exceed the amount you paid to us in the past 12 months.',
      ],
    },
    {
      title: '8. Governing Law',
      content: [
        'These terms shall be governed by and construed in accordance with the laws of India.',
        'Any disputes arising under these terms shall be subject to the exclusive jurisdiction of the courts in Mumbai, India.',
      ],
    },
    {
      title: '9. Contact Information',
      content: [
        'For any questions regarding these terms, please contact us at legal@yantrai.com.',
      ],
    },
  ];

  return (
    <div
      className="p-4 lg:p-8 min-h-screen pb-24"
      style={{ backgroundColor: colors.backgroundColor }}
    >
      <div className="lg:max-w-3xl lg:mx-auto">
        <CHeader title="Terms & Conditions" />

        {/* Last Updated Badge */}
        <div
          className="inline-block px-3 py-1 rounded-full mb-6"
          style={{ backgroundColor: colors.primary + '20' }}
        >
          <CText type="r12" color={colors.primary}>
            Last Updated: January 2026
          </CText>
        </div>

        {/* Terms Content */}
        <div className="space-y-6">
          {termsData.map((section, index) => (
            <div key={index}>
              <CText type="B16" color={colors.textColor} style={{ marginBottom: 8 }}>
                {section.title}
              </CText>
              {section.content.map((paragraph, pIndex) => (
                <CText
                  key={pIndex}
                  type="r14"
                  color={colors.grayScale500}
                  style={{ marginBottom: 8, lineHeight: 1.6 }}
                >
                  {paragraph}
                </CText>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TermsAndCondition;
